import http from "@/plugins/axios";

export default http.axiosInstance